import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
} from '@orderna/admin-panel/src/utils/service';
import { TRANSACTIONS } from '../../data/transactions';
import {
  ITransaction,
  Transaction,
} from '../../model/transaction';
import { ITransactionsApiService } from './transactions-api.interface';
import { FindTransactionsQueryDto } from './dtos/find-transactions.query.dto';
import { FindTransactionsResponseDto } from './dtos/find-transactions.response.dto';
import { CreateTransactionRequestDto } from './dtos/create-transaction.request.dto';
import { CreateTransactionResponseDto } from './dtos/create-transaction.response.dto';
import { FindTransactionDetailsResponseDto } from './dtos/find-transaction-details.response.dto';
import { FindTransactionReversalDetailsResponseDto } from './transaction-reversal/dtos/find-transaction-reversal-details.response.dto';
import { ReverseTransactionRequestDto } from './transaction-reversal/dtos/reverse-transaction.request.dto';
import { ReverseTransactionResponseDto } from './transaction-reversal/dtos/reverse-transaction.response.dto';

@Injectable({
  providedIn: 'root',
})
export class TransactionsMockApiService implements ITransactionsApiService {
  data = {
    transactions: {
      items: [...TRANSACTIONS],
      queryOptions: { page: 1, size: 10 } as QueryOptions<ITransaction>,
      subject: new BehaviorSubject<Maybe<Transaction[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get transactionsData() {
    return this.data['transactions'] as Data<Transaction, ITransaction>;
  }

  findTransactions(query: FindTransactionsQueryDto): Promise<FindTransactionsResponseDto> {
    throw new Error('Method not implemented.');
  }

  findTransactionDetails(uuid: string): Promise<FindTransactionDetailsResponseDto> {
    throw new Error('Method not implemented.');
  }

  createTransaction(data: CreateTransactionRequestDto): Promise<CreateTransactionResponseDto> {
    throw new Error('Method not implemented.');
  }
}
